import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import api from '../../../utils/api';

export default function CertificateTemplatePreviewModal({ open, onOpenChange, template, schoolId }) {
  const [loading, setLoading] = useState(false);
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !template?.id || !schoolId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    api.get('/reports/templates/preview', { params: { template_id: template.id, school_id: schoolId } })
      .then((res) => {
        if (cancelled) return;
        setHtml(res.data?.data?.html || '');
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.response?.data?.message || 'Failed to load preview');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [open, template?.id, schoolId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] h-[90vh] flex flex-col">
        <DialogHeader><DialogTitle>{template?.name || 'Certificate preview'}</DialogTitle></DialogHeader>
        <div className="flex-1 min-h-0 rounded-lg border overflow-hidden bg-white">
          {loading ? <div className="h-full flex items-center justify-center text-muted-foreground">Loading…</div>
            : error ? <div className="h-full flex items-center justify-center text-red-500">{error}</div>
              : <iframe title="cert-full-preview" className="w-full h-full" sandbox="allow-same-origin" srcDoc={html} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
